import { QueryClient, QueryKey } from "react-query";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ICacheQueryData<T extends Array<any>> = (
  ...queries: IQueries<T>
) => void;

export type IQuery<Type> = {
  key: QueryKey;
  value: Type;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type IQueries<Types extends Array<any>> = IQuery<Types[number]>[];

const init = (): QueryClient => {
  const client = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
      },
    },
  });

  return client;
};

export const dataLayer = init();

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const cacheQueryData: ICacheQueryData<any[]> = (...queries) => {
  Object.keys(queries).forEach((key) => {
    dataLayer.setQueryData(queries[key].key, queries[key].value);
  });
};
